import { FC } from 'react'
import { ProductCard } from '@components/product'
import Slider from 'react-slick'
import { Product } from '@commerce/types'
import cn from 'clsx'

interface props {
  products: any[]
}

const AddonProducts: FC<props> = ({ products }) => {
  if (!products) return null
  const sliderSettings = {
    className: cn({ 'hide-slider': products.length < 5 }),
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          className: cn({ 'hide-slider': products.length < 5 }),
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true,
          dots: true,
          arrows: true,
        },
      },
      {
        breakpoint: 425,
        settings: {
          className: cn({ 'hide-slider': products.length < 2 }),
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          className: cn({ 'hide-slider': products.length < 3 }),
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
          arrows: false,
        },
      },
    ],
  }

  return (
    <div className={cn('wrapper mt-24 mb-14 laptop:mb-16 product-slick')}>
      <div className="uppercase text-ui-darkest-grey font-normal text-20 leading-6 laptop:text-24 laptop:leading-8">
        Complete The Look
      </div>
      <div className="mt-24">
        <Slider {...sliderSettings}>
          {products.map((product: Product.Product) => {
            const namedTags: any = {}
            product.tags
              ?.filter((tag: string) => tag.indexOf(':') > 0)
              .forEach((tag: string) => {
                namedTags[tag.split(':')[0]] = tag.split(':')[1]
              })
            const brandTags = namedTags?.Brand
            const brand =
              typeof brandTags === 'string' ? brandTags : brandTags?.[0]
            const formattedBrand: string =
              brand?.replace(/_/g, ' ') || 'Hoskings Jewellers'
            return (
              <ProductCard
                key={product.id}
                id={product.id}
                name={product.name}
                description={product.description}
                price={product.price?.value}
                compareAtPrice={product.price?.listPrice}
                images={product.images}
                link={product.path}
                brand={formattedBrand}
                namedTags={namedTags}
                tags={product.tags ? product.tags : []}
              />
            )
          })}
        </Slider>
        <div
          className={cn('gap-4 tablet:gap-6 laptop:gap-8', {
            hidden: products.length > 4,
            'hidden desktop:flex': products.length === 4,
            'hidden laptop:flex': products.length === 3,
            'hidden tablet:flex': products.length === 2,
            'mobileS:flex': products.length === 1,
          })}
        >
          {products.map((product: Product.Product) => {
            const namedTags: any = {}
            product.tags
              ?.filter((tag: string) => tag.indexOf(':') > 0)
              .forEach((tag: string) => {
                namedTags[tag.split(':')[0]] = tag.split(':')[1]
              })
            const brand: string =
              namedTags?.Brand?.replace(/_/g, ' ') || 'Hoskings Jewellers'
            return (
              <div
                key={product.id}
                className="w-32 mobileM:w-164 mobileL:w-183 tablet:w-208 desktop:w-1/5"
              >
                <ProductCard
                  key={product.id}
                  id={product.id}
                  name={product.name}
                  description={product.description}
                  price={product.price?.value}
                  compareAtPrice={product.price?.listPrice}
                  images={product.images}
                  link={product.path}
                  brand={brand}
                  namedTags={namedTags}
                  tags={product.tags ? product.tags : []}
                />
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default AddonProducts
